/* DTTS Site Map — pin <-> legend cross-highlight + fullscreen zoom viewer */
(function () {
  'use strict';

  function clearActive(scope) {
    scope.querySelectorAll('.dtts-site-map__pin.is-active').forEach(function (el) {
      el.classList.remove('is-active');
    });
    scope.querySelectorAll('.dtts-site-map__legend-item.is-active').forEach(function (el) {
      el.classList.remove('is-active');
    });
  }

  function activate(section, id) {
    clearActive(section);
    var pin = section.querySelector('.dtts-site-map__pin[data-pin-target="' + id + '"]');
    var item = section.querySelector('.dtts-site-map__legend-item[data-legend-id="' + id + '"]');
    if (pin) pin.classList.add('is-active');
    if (item) item.classList.add('is-active');
    return item;
  }

  /* ------------------------------------------------
     Fullscreen zoom viewer (pinch + drag + buttons)
     ------------------------------------------------ */
  var viewer = null;

  function buildViewer() {
    if (viewer) return viewer;

    var overlay = document.createElement('div');
    overlay.className = 'dtts-site-map__viewer';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML =
      '<div class="dtts-site-map__viewer-stage">' +
        '<img class="dtts-site-map__viewer-img" alt="" draggable="false">' +
      '</div>' +
      '<span class="dtts-site-map__viewer-hint">Pinch or use + / − to zoom · drag to pan</span>' +
      '<button type="button" class="dtts-site-map__viewer-close" aria-label="Close map">' +
        '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
      '</button>' +
      '<div class="dtts-site-map__viewer-controls">' +
        '<button type="button" class="dtts-site-map__viewer-btn" data-zoom="out" aria-label="Zoom out">−</button>' +
        '<button type="button" class="dtts-site-map__viewer-btn" data-zoom="reset" aria-label="Reset zoom"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg></button>' +
        '<button type="button" class="dtts-site-map__viewer-btn" data-zoom="in" aria-label="Zoom in">+</button>' +
      '</div>';
    document.body.appendChild(overlay);

    var stage = overlay.querySelector('.dtts-site-map__viewer-stage');
    var img = overlay.querySelector('.dtts-site-map__viewer-img');

    var state = { scale: 1, x: 0, y: 0, fit: 1 };
    var pointers = {};
    var pinchStart = null;
    var dragStart = null;
    var lastTap = 0;

    function apply() {
      img.style.transform = 'translate(' + state.x + 'px,' + state.y + 'px) scale(' + state.scale + ')';
    }

    function clampScale(s) {
      return Math.max(state.fit * 0.9, Math.min(state.fit * 8, s));
    }

    function fitImage() {
      var vw = overlay.clientWidth;
      var vh = overlay.clientHeight;
      var nw = img.naturalWidth || vw;
      var nh = img.naturalHeight || vh;
      state.fit = Math.min(vw / nw, vh / nh);
      state.scale = state.fit;
      state.x = (vw - nw * state.scale) / 2;
      state.y = (vh - nh * state.scale) / 2;
      apply();
    }

    function zoomTo(newScale, fx, fy) {
      newScale = clampScale(newScale);
      state.x = fx - (fx - state.x) * (newScale / state.scale);
      state.y = fy - (fy - state.y) * (newScale / state.scale);
      state.scale = newScale;
      apply();
    }

    function dist(a, b) {
      return Math.hypot(a.x - b.x, a.y - b.y);
    }
    function mid(a, b) {
      return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
    }

    stage.addEventListener('pointerdown', function (e) {
      stage.setPointerCapture(e.pointerId);
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pointers);
      if (ids.length === 2) {
        var p = pointers[ids[0]];
        var q = pointers[ids[1]];
        pinchStart = { dist: dist(p, q), scale: state.scale };
        dragStart = null;
      } else if (ids.length === 1) {
        dragStart = { x: e.clientX, y: e.clientY, ox: state.x, oy: state.y };
        stage.classList.add('is-panning');
        /* double-tap to toggle zoom */
        var now = Date.now();
        if (now - lastTap < 300) {
          var target = state.scale > state.fit * 1.2 ? state.fit : state.fit * 2.6;
          zoomTo(target, e.clientX, e.clientY);
          lastTap = 0;
        } else {
          lastTap = now;
        }
      }
    });

    stage.addEventListener('pointermove', function (e) {
      if (!pointers[e.pointerId]) return;
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pointers);
      if (ids.length === 2 && pinchStart) {
        var p = pointers[ids[0]];
        var q = pointers[ids[1]];
        var m = mid(p, q);
        var ratio = dist(p, q) / pinchStart.dist;
        zoomTo(pinchStart.scale * ratio, m.x, m.y);
      } else if (ids.length === 1 && dragStart) {
        state.x = dragStart.ox + (e.clientX - dragStart.x);
        state.y = dragStart.oy + (e.clientY - dragStart.y);
        apply();
      }
    });

    function endPointer(e) {
      delete pointers[e.pointerId];
      if (Object.keys(pointers).length < 2) pinchStart = null;
      if (Object.keys(pointers).length === 0) {
        dragStart = null;
        stage.classList.remove('is-panning');
      }
    }
    stage.addEventListener('pointerup', endPointer);
    stage.addEventListener('pointercancel', endPointer);

    /* Mouse wheel zoom (desktop) */
    stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      var factor = e.deltaY < 0 ? 1.15 : 1 / 1.15;
      zoomTo(state.scale * factor, e.clientX, e.clientY);
    }, { passive: false });

    overlay.querySelectorAll('[data-zoom]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cx = overlay.clientWidth / 2;
        var cy = overlay.clientHeight / 2;
        var z = btn.dataset.zoom;
        if (z === 'in') zoomTo(state.scale * 1.4, cx, cy);
        else if (z === 'out') zoomTo(state.scale / 1.4, cx, cy);
        else fitImage();
      });
    });

    function close() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }
    overlay.querySelector('.dtts-site-map__viewer-close').addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });

    viewer = {
      open: function (src, alt) {
        img.alt = alt || '';
        var onload = function () {
          img.removeEventListener('load', onload);
          fitImage();
        };
        img.addEventListener('load', onload);
        img.src = src;
        if (img.complete && img.naturalWidth) fitImage();
        overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
      }
    };
    return viewer;
  }

  function initZoom(section) {
    var wrap = section.querySelector('[data-site-map-zoom-src]');
    if (!wrap) return;
    var src = wrap.getAttribute('data-site-map-zoom-src');
    var alt = wrap.getAttribute('data-site-map-zoom-alt') || '';
    if (!src) return;

    var open = function (e) {
      e.preventDefault();
      buildViewer().open(src, alt);
    };

    /* Dedicated "Tap to zoom" button */
    var btn = section.querySelector('[data-site-map-zoom]');
    if (btn) btn.addEventListener('click', open);

    /* Tapping the map image itself (but not a pin) also opens the viewer */
    var image = section.querySelector('.dtts-site-map__image');
    if (image) {
      image.style.cursor = 'zoom-in';
      image.addEventListener('click', open);
    }
  }

  function init(section) {
    section.querySelectorAll('.dtts-site-map__pin').forEach(function (pin) {
      pin.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = pin.dataset.pinTarget;
        var item = activate(section, id);
        if (item) {
          item.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    });

    section.querySelectorAll('.dtts-site-map__legend-item').forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        var id = item.dataset.legendId;
        activate(section, id);
      });
      item.addEventListener('mouseleave', function () {
        clearActive(section);
      });
      item.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        var id = item.dataset.legendId;
        activate(section, id);
        var pin = section.querySelector('.dtts-site-map__pin[data-pin-target="' + id + '"]');
        if (pin) pin.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    initZoom(section);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.dtts-site-map').forEach(init);
  });
})();
